import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogInput } from './confirm-dialog.models';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
	selector: 'pcode-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent
{
	// form
	public form = this.fb.group(
		{
			notes: this.fb.control(null, [Validators.maxLength(1000)]),
		}
	);
	get notes() { return this.form.get('notes'); }

	// constructor
	constructor
		(
			private dialogRef: MatDialogRef<ConfirmDialogComponent>,
			@Inject(MAT_DIALOG_DATA) public model: ConfirmDialogInput,
			private fb: FormBuilder
		)
	{
		if (model.notesEnabled && model.notesMandatory)
			this.notes.setValidators([Validators.required, Validators.maxLength(1000)]);
		else if (!model.notesEnabled)
			this.form.disable();
	}

	// follow link
	confirm(customAction: string = null)
	{
		this.dialogRef.close({ confirmed: true, notes: this.notes.value, customAction: customAction });
	}
}
